import { EntryType } from 'shared/models/sheet/Sheet';

export enum StatusNames {
    SUBMITTED = 'Submitted',
    WORKING = 'Working',
    APPROVED = 'Approved',
    APPROVED_CLOSED = 'Approved - Closed',
    REJECTED = 'Rejected',
    RECALLED = 'Recalled',
    AWAITING_FINAL_APPROVAL = 'Awaiting Final Approval',
    MISSING = 'Missing',
    ALL = 'All',
}

// Missing status is calculated so it is not present on StatusNames
export const missingStatusName = 'Missing';

export enum SheetStatusSlug {
    SUBMITTED = 'submitted',
    WORKING = 'working',
    APPROVED = 'approved',
    APPROVED_CLOSED = 'approved_closed',
    REJECTED = 'rejected',
    RECALLED = 'recalled',
    AWAITING_FINAL_APPROVAL = 'awaiting_final_approval',
}

export const statusSlugToName: Record<SheetStatusSlug, StatusNames> = {
    [SheetStatusSlug.WORKING]: StatusNames.WORKING,
    [SheetStatusSlug.SUBMITTED]: StatusNames.SUBMITTED,
    [SheetStatusSlug.APPROVED]: StatusNames.APPROVED,
    [SheetStatusSlug.APPROVED_CLOSED]: StatusNames.APPROVED_CLOSED,
    [SheetStatusSlug.REJECTED]: StatusNames.REJECTED,
    [SheetStatusSlug.RECALLED]: StatusNames.RECALLED,
    [SheetStatusSlug.AWAITING_FINAL_APPROVAL]: StatusNames.AWAITING_FINAL_APPROVAL,
};

export interface IUpdateSheetsStatus {
    sheets: Array<IUpdateSheetStatus>;
}

export interface IUpdateSheetStatus {
    id: string;
    status_id: string;
    notes?: string | null;
    california_submission_attestation?: boolean | null;
}

export interface ISheetIdAndType {
    id: string;
    sheetType: EntryType;
}
export type SheetsEntryTypes = Record<string, EntryType>;

export type NoteEntry = Record<string, string>;

export interface ISheetStatusChange {
    statusName: StatusNames;
    sheetsEntryTypes: SheetsEntryTypes;
    notes?: NoteEntry;
    californiaSubmission?: boolean;
}
